module.exports = __webpack_public_path__ + "media/coffee-preferences/country_of_origin_dr_congo-dc8a61ca.png";